import { MatDialog } from '@angular/material/dialog';
import { Injectable } from '@angular/core';
import { ApiService } from 'app/shared/apis/api.service';
import { BaseService } from 'app/core/services/base.service';
import { FileModuleModel } from 'app/models/file_module.model';

@Injectable({
    providedIn: 'root',
})
export class FileModuleService extends BaseService<FileModuleModel> {
    constructor(api: ApiService, _matDialog: MatDialog) {
        super(api, _matDialog, 'fileModule');
    }
}
